import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from '../../../../../components/global/Spinner';

const propTypes = {
  className: PropTypes.string,
};

const Placeholder = ({ className }) => {
  const classes = classNames({
    'text-center p-6': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <Spinner />
    </div>
  );
};

Placeholder.propTypes = propTypes;

export default Placeholder;
